import {  styled } from "@mui/material/styles";
import {  TextField, TextFieldProps } from "@mui/material";


const CustomTextfield = styled(({ ...props }) => <TextField {...props} />)(
  ({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(2.5),
    },
    ".MuiFormLabel-root":{
      marginTop:"-10px",
      // color:theme.palette.primary.main
      color: "#2F426F"
            },
    
            ".MuiInputLabel-shrink":{
              marginTop: "0px"
          }
      ,
    
    "& .MuiOutlinedInput-root": {
      "& .MuiSelect-select": {
        // minHeight: "37px",
        padding:"6px 12px"
      },
      "& .MuiSelect-nativeInput":{
        border:"none"
      }
    },
    ".MuiOutlinedInput-root":{
      padding:"0",
      
   
      "& textarea":{
        padding:"6px 12px"
      }
    },
    ".MuiOutlinedInput-notchedOutline": {
      // border: "none",
      border: "1px solid rgba(47, 66, 111, 0.30)",
      borderRadius: "15px",
      
    },
    "& .MuiInputBase-input": {
      
      margin: "0",
      padding: "0 12px",

      minHeight: "29px",
      borderRadius: "15px",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      position: "relative",
      // backgroundColor: "transparent",
      backgroundColor:"#fff",
      borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
      
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),

      color: theme.palette.primary.main,
      "::placeholder": {
       
        color: "inherit", // Set the placeholder color to inherit from the parent
        opacity: 0.5, // Adjust placeholder opacity as needed
      },
      "&:-webkit-autofill":{
        borderRadius:"20px"
      },
      "&:disabled": {},
      "&:focus": {
        borderColor:"#2f426f"
      },
    },

    "@media (min-width: 992px)":{
    
      
      "& .MuiOutlinedInput-root": {
        "& .MuiSelect-select": {
          padding:"9px 12px"
       
          // padding:"0 12px",
          
          
        }
       
      },
      ".MuiOutlinedInput-root":{
       
        "& textarea":{
          padding:"9px 12px"
        }
      },
      ".MuiOutlinedInput-notchedOutline": {
        borderRadius: "20px",
      },
      "& .MuiInputBase-input": {
        minHeight: "36px",
        borderRadius: "20px",
        fontSize: "14px",
      },
    }
  })
);

export default function StyledTextfield(rest: TextFieldProps) {
  return <CustomTextfield  {...rest} />;
}


